import React from 'react';
import { observer } from 'mobx-react';
import { Collapse, Form } from 'antd';
import { Rule } from 'antd/es/form';
import { CardLayout, cardLayoutOptions } from '../../Layout';
import { CardInfoToolBar } from '../../SubComponents';
import { IBodyItemResponse, IEsNotificationsDownloadOrderBody, NotificationType } from '../../../interfaces';
import { useUiIsSpinnerFound } from '../../../hooks';
import { addNotification, apiMessagesGetFormRules, postEsNotificationsDownloadOrder } from '../../../middleware';
import { Catcher } from '../../Catcher';
import { InputDebounce } from '../../Forms';

const { Panel } = Collapse;

export const Es2DownloadForm: React.FC = observer(() => {
    const [form] = Form.useForm();
    const isLoading = useUiIsSpinnerFound(['POST_ES2_PLUS_DOWNLOAD_ORDER']);

    const ruleRequired: Array<Rule> = [{ required: true, message: 'Required' }, ...apiMessagesGetFormRules];

    const onFinish = async (fields: any): Promise<void> => {
        const body = {
            header: {
                functionCallIdentifier: fields.functionCallIdentifier,
                functionRequesterIdentifier: fields.functionRequesterIdentifier,
            },
            iccid: fields.iccid,
            eid: fields.eid,
        } as IEsNotificationsDownloadOrderBody;

        const { isError, resp } = await postEsNotificationsDownloadOrder(body);

        const { header, ReasonCode } = resp as IBodyItemResponse;

        if (isError) {
            addNotification({
                type: NotificationType.ERROR,
                message: 'Error!',
                description: `Something went wrong`,
                duration: 5,
            });

            return;
        }

        if (ReasonCode) {
            addNotification({
                type: NotificationType.ERROR,
                message: 'Error!',
                description: JSON.stringify(header),
                duration: 10,
            });
        } else {
            addNotification({
                type: NotificationType.SUCCESS,
                message: 'Downloaded',
                description: `Your order has been downloaded successfully`,
                duration: 5,
            });
        }
    };

    return (
        <Catcher>
            <CardLayout
                title={'Download Order'}
                idSpinners={['POST_ES2_PLUS_DOWNLOAD_ORDER']}
                dataTest={'EditCompanyContactInfo'}
                columnOption={cardLayoutOptions.cardEditCompany}
            >
                <Form
                    form={form}
                    name="download_order"
                    initialValues={{ functionCallIdentifier: 'TX-567', functionRequesterIdentifier: '2' }}
                    onFinish={onFinish}
                    scrollToFirstError={true}
                    layout={'vertical'}
                    className={'formStyle'}
                >
                    <Form.Item name="eid" label={'eid'}>
                        <InputDebounce autoComplete={'off'} placeholder={'eid'} isFirstInput />
                    </Form.Item>
                    <Form.Item name="iccid" label={'iccid'} rules={ruleRequired}>
                        <InputDebounce autoComplete={'off'} placeholder={'iccid'} />
                    </Form.Item>
                    <Collapse style={{ marginTop: '10px', marginBottom: '10px' }} bordered={false}>
                        <Panel key={'1'} header={'Headers'}>
                            <Form.Item name="functionCallIdentifier" label={'functionCallIdentifier'}>
                                <InputDebounce autoComplete={'off'} placeholder={'functionCallIdentifier'} />
                            </Form.Item>
                            <Form.Item name="functionRequesterIdentifier" label={'functionRequesterIdentifier'}>
                                <InputDebounce autoComplete={'off'} placeholder={'functionRequesterIdentifier'} />
                            </Form.Item>
                        </Panel>
                    </Collapse>
                    <CardInfoToolBar
                        isLoading={isLoading}
                        isHideBack={true}
                        isSubmitButton={true}
                        labelSave={'Download'}
                    />
                </Form>
            </CardLayout>
        </Catcher>
    );
});
